// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"562":"38820bc2","888":"6d721b39"}[chunkId] + ".css";
};